// Radha — set/view custom field values for a collection account (056), shown
// when a Collections row is expanded. Only renders once at least one field
// is defined (Settings → Custom fields) — otherwise silently absent so
// tenants who haven't used the feature see no change.
import React, { useState } from "react";

import { useCustomFieldDefinitions, useCustomFieldValues, useSetCustomFieldValue } from "../hooks/useEnterprise";

function FieldInput({ accountId, fieldKey, type, current }: { accountId: string; fieldKey: string; type: string; current: string | null }) {
  const set = useSetCustomFieldValue();
  const [value, setValue] = useState(current ?? "");
  const save = () => {
    if (value === (current ?? "")) return;
    set.mutate({ entity_id: accountId, field_key: fieldKey, value });
  };
  return (
    <input
      type={type === "number" ? "number" : type === "date" ? "date" : "text"}
      value={value} onChange={(e) => setValue(e.target.value)} onBlur={save}
      style={{ width: 140, padding: "3px 7px", fontSize: 12, border: "1px solid var(--border)", borderRadius: 5, background: "var(--surface)", color: "var(--fg)" }}
    />
  );
}

export function CustomFieldsRow({ accountId, canWrite }: { accountId: string; canWrite: boolean }) {
  const { data: defs } = useCustomFieldDefinitions();
  const { data: values } = useCustomFieldValues(accountId);
  if (!defs || defs.length === 0) return null;
  const valueByKey = new Map((values ?? []).map((v) => [v.field_key, v.value]));

  return (
    <div style={{ display: "flex", gap: 16, flexWrap: "wrap", padding: "6px 0", fontSize: 12, color: "var(--fg-muted)" }} onClick={(e) => e.stopPropagation()}>
      {defs.map((d) => (
        <span key={d.id} style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {d.field_label}:
          {canWrite ? (
            <FieldInput accountId={accountId} fieldKey={d.field_key} type={d.field_type} current={valueByKey.get(d.field_key) ?? null} />
          ) : <span style={{ color: "var(--fg)" }}>{valueByKey.get(d.field_key) ?? "—"}</span>}
        </span>
      ))}
    </div>
  );
}
